// extracted by mini-css-extract-plugin
module.exports = {"root":"InputSecondary_root__1pI4W","error":"InputSecondary_error__zvPw_","disabled":"InputSecondary_disabled__1_2Cu"};